"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecContext = void 0;
class ExecContext {
    constructor(_traceContext, _logger, _progress) {
        this._traceContext = _traceContext;
        this._logger = _logger;
        this._progress = _progress;
        this._groupLogger = undefined;
    }
    get traceContext() { return this._traceContext; }
    get logger() {
        if (this._groupLogger) {
            return this._groupLogger;
        }
        return this._logger;
    }
    get progress() { return this._progress; }
    startGroup() {
        if (!this._groupLogger) {
            this._groupLogger = this._logger.fork();
        }
    }
    endGroup() {
        if (this._groupLogger) {
            this._logger.mergeIn(this._groupLogger, true);
            this._groupLogger = undefined;
        }
    }
}
exports.ExecContext = ExecContext;
//# sourceMappingURL=exec-context.js.map